import { ProjectTrackingData } from "../constants/ProjectTrackingData";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import { BsCheckCircleFill } from "react-icons/bs";

const ProjectTrackingCard = () => {
  return (
    <div className="max-w-full rounded-lg bg-white shadow-md">
      <h3 className="p-4 text-lg font-medium">Project tracking</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="flex w-full gap-10 overflow-x-auto p-4">
        {ProjectTrackingData.map((data, index) => {
          return (
            <div className="flex flex-col items-center gap-2" key={index}>
              <span className="text-center font-medium">{data.title}</span>
              <p className="text-center text-sm text-gray-500">{data.date}</p>
              {data.status === "Completed" ? (
                <p className="text-green-700">
                  <BsCheckCircleFill />
                </p>
              ) : (
                <p className="text-orange-400">
                  <MdOutlineRadioButtonChecked size={20} />
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectTrackingCard;
